import {
  getPointsPartitionDisplayText,
  getPointsPartitionRangeSize,
  PointsPartition,
} from "model/PickemDetails/PointsPartition";
import { selectRosterDisplayName } from "selectors/Roster";
import { FlexRow } from "styles/layout";
import {
  GroupOrgLogoContainer,
  GroupDisplayName,
  MobileGroupDisplayName,
  RankSelectBox,
} from "./styles";
import { Pick } from "model/Pickem/Pickem";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { useAppSelector } from "app/hooks";

interface Props {
  columns: PointsPartition[];
  rosterId: string;
  tournamentId: string;
  frozen: boolean;
  frozenPositions: number[];
  gridPicks: { [rosterId: string]: Pick };
  updatePick: (rosterId: string, position: number | undefined) => void;
}

export const RankemGridRow = ({
  columns,
  rosterId,
  tournamentId,
  frozen,
  frozenPositions,
  gridPicks,
  updatePick,
}: Props) => {
  const orgName = useAppSelector((state) =>
    selectRosterDisplayName(state, rosterId, tournamentId)
  );

  const sortedColumns = [...columns].sort((a, b) => a.position - b.position);
  const rosterPick = gridPicks[rosterId];
  const otherPicks = Object.keys(gridPicks)
    .filter((id) => id !== rosterId)
    .map((id) => gridPicks[id]);

  return (
    <tr key={rosterId}>
      <td>
        <FlexRow>
          <GroupOrgLogoContainer frozen={frozen}>
            <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
          </GroupOrgLogoContainer>
          <GroupDisplayName frozen={frozen}>{orgName}</GroupDisplayName>
          <MobileGroupDisplayName frozen={frozen}>
            {orgName}
          </MobileGroupDisplayName>
        </FlexRow>
      </td>
      {sortedColumns.map((col) => {
        const colSize = getPointsPartitionRangeSize(col);
        const availableToSelect =
          otherPicks.filter((p) => p === col.position).length < colSize;
        return (
          <td>
            <RankSelectBox
              selected={rosterPick === col.position}
              otherSelected={!!rosterPick && rosterPick !== col.position}
              availableToSelect={availableToSelect}
              frozen={frozen || frozenPositions.includes(col.position)}
              fontSize={
                colSize === 1
                  ? "normal"
                  : col.position && (col.endPosition ?? 1) < 10
                  ? "small"
                  : "smaller"
              }
              onClick={
                availableToSelect &&
                !frozen &&
                !frozenPositions.includes(col.position)
                  ? () => updatePick(rosterId, col.position)
                  : undefined
              }
            >
              {getPointsPartitionDisplayText(col)}
            </RankSelectBox>
          </td>
        );
      })}
    </tr>
  );
};
